import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { motion } from 'framer-motion';

const gradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.4);
  }
  70% {
    box-shadow: 0 0 0 20px rgba(255, 0, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
`;

const orbitAnimation = keyframes`
  from {
    transform: rotate(0deg) translateX(80px) rotate(0deg);
  }
  to {
    transform: rotate(360deg) translateX(80px) rotate(-360deg);
  }
`;

const SplashContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(-45deg, #ff000022, #ffffff, #ff000015, #ffffff);
  background-size: 400% 400%;
  animation: ${gradientAnimation} 15s ease infinite;
  position: relative;
  overflow: hidden;
`;

interface OrbitingDotProps {
  delay: number;
}

const OrbitingDot = styled.div<OrbitingDotProps>`
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #ff0000;
  border-radius: 50%;
  opacity: 0.6;
  animation: ${orbitAnimation} 3s linear infinite;
  animation-delay: ${props => props.delay}s;
`;

const Logo = styled(motion.div)`
  width: 120px;
  height: 120px;
  background-color: #ff0000;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  line-height: 1.2;
  position: relative;
  animation: ${pulseAnimation} 2s infinite;
  box-shadow: 0 0 30px rgba(255, 0, 0, 0.3);

  &::before {
    content: '';
    position: absolute;
    top: -10px;
    left: -10px;
    right: -10px;
    bottom: -10px;
    border: 2px solid #ff0000;
    border-radius: 50%;
    animation: ${pulseAnimation} 2s infinite;
    opacity: 0.5;
  }
`;

const LoadingText = styled(motion.div)`
  margin-top: 30px;
  font-size: 16px;
  color: #ff0000;
  font-weight: 500;
  letter-spacing: 2px;
  opacity: 0.8;
`;

const SplashScreen = () => {
  const orbitCount = 8;
  const orbits = Array.from({ length: orbitCount }, (_, i) => ({
    delay: (i / orbitCount) * 3,
  }));

  return (
    <SplashContainer>
      {orbits.map((orbit, index) => (
        <OrbitingDot
          key={index}
          delay={orbit.delay}
        />
      ))}
      <Logo
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{
          duration: 0.8,
          ease: "easeOut",
          delay: 0.2,
        }}
      >
        STYLE<br /><span style={{fontWeight: '900',fontSize: '25px'}}>BOX</span>
      </Logo>
      {/* <LoadingText
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
      >
        LOADING...
      </LoadingText> */}
    </SplashContainer>
  );
};

export default SplashScreen; 